import {
  ChatAPI,
  getChat,
  getCurrentChat,
  setFeedbackSubmitted,
  setChatLoading,
  setCurrentChatSession,
} from '@guuru/chat-web';
import events from '@guuru/events-web';
import { client } from '@guuru/graphql-web';
import createOrUpdateUser from '../../commands/createOrUpdateUser';
import handleChatStatusChange from '../../commands/handleChatStatusChange';
import postHeightUpdate from '../../commands/postHeightUpdate';
import JOIN_CHAT from './mutations/JoinChat';

const storeQuestion = (chatData) => {
  const chatQuestion = chatData.question;
  ChatAPI.storeQuestion(chatQuestion);
};

const storeUserPredictionAnswer = (chatData) => {
  const userAnsweredPrediction = chatData?.messages?.edges.find(
    ({ node }) => node?.metadata?.isUserPredictionAnswer,
  );
  const answer = userAnsweredPrediction?.node?.metadata?.response;
  ChatAPI.storeUserPredictionAnswer(answer);
};

const storeFeedback = (chatData) => {
  const chatFeedback = chatData?.feedback;
  const chatNps = chatData?.npsRating;

  const hasFeedback = chatFeedback?.topics?.length ?? chatFeedback?.comment;
  if (!hasFeedback && !chatNps) return null;
  return setFeedbackSubmitted(true);
};

const loadChat = async ({ partnerId, chatId, chatControlToken, action }) => {
  const { navigate, location } = action;
  let channel = ChatAPI.storeRetrieveChannel();
  await createOrUpdateUser(partnerId);
  let chatData = null;
  try {
    await client.mutate({
      mutation: JOIN_CHAT,
      variables: { id: chatId, chatControlToken },
    });
    chatData = await getChat(chatId, true);
    ChatAPI.storeChatControlToken(partnerId, chatId, chatControlToken);
  } catch (_) {
    ChatAPI.storeReset(partnerId);
    const chatUrl = ChatAPI.getChatURL(partnerId, channel, {
      qs: location.search,
    });
    navigate(chatUrl, { replace: true });
  }
  if (chatData) {
    events.loadExistingChat();

    storeQuestion(chatData);
    storeUserPredictionAnswer(chatData);
    storeFeedback(chatData);

    channel = chatData.channel;
    ChatAPI.storeChannel(partnerId, channel);

    const chatUrl = ChatAPI.getChatURL(partnerId, channel, {
      chatId,
      token: chatControlToken,
      qs: location.search,
    });
    window.history.replaceState({}, '', chatUrl);

    handleChatStatusChange({ chatId, ...chatData });

    setCurrentChatSession({
      chatId,
      messages: chatData.messages.edges || [],
    });

    setChatLoading(false);

    postHeightUpdate();
    return true;
  }
  return false;
};

// It a user access a direct link ( chatId is available ) then the
// chat should be displayed even if it is rated. If not, we must try
// to load the existing chat from localstorage but if this chat is
// already closed, then we should reset to homepage
const chatLoad = {
  validate() {
    return true;
  },

  async render(partnerId, { action }) {
    // Use given chat id or use a stored one If there is an active chat,
    // redirect to chat view
    const { chatId: activeChatId } = getCurrentChat();
    const activeChatControlToken =
      action.chatControlToken ||
      ChatAPI.storeRetrieveChatControlToken(partnerId, activeChatId);

    const hasActiveChat =
      typeof activeChatId === 'string' &&
      activeChatId.length > 0 &&
      typeof activeChatControlToken === 'string' &&
      activeChatControlToken.length > 0;
    if (!hasActiveChat) {
      return { goToNextStep: true };
    }

    const chatLoaded = await loadChat({
      partnerId,
      chatId: activeChatId,
      chatControlToken: activeChatControlToken,
      action,
    });
    return { goToNextStep: !chatLoaded };
  },
};

export default chatLoad;
